<template>
<div class="LimitTimeEdit">
    <div class="message">
        <el-alert title="" type="warning" show-icon :closable="false">请您遵守国家相关规定，切勿上传低俗色情、暴力恐怖、谣言诈骗、侵权盗版等相关内容。
        </el-alert>
    </div>
    <div class="account-form form">
        <el-form :model="item" :rules="rules" ref="ruleForm" label-width="120px" class="demo-item"
                 label-position="left" size="mini">
            <div class="classes blod">活动信息</div>
            <el-form-item label="活动名称" prop="assetname" class="box">
                <el-input v-model.trim="item.assetname" placeholder="请输入活动名称" maxlength="20" show-word-limit
                          clearable :disabled="disabled"></el-input>
            </el-form-item>
            <el-form-item label="活动时间" class="box" prop="timeSlot">
                <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" :disabled="disabled"
                                v-model="item.timeSlot"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="活动标签" prop="tagname" class="box tagname">
                <el-input v-model.trim="item.tagname" placeholder="请输入活动标签" minlength="2" maxlength="5"
                          show-word-limit
                          clearable :disabled="disabled"></el-input>
                <div class="tip">活动期间展示于商品详情的价格旁边，2至5字。</div>
            </el-form-item>
            <div class="classes blod">商品信息</div>
            <div class="limit-btns" v-if="!disabled">
                <el-button type="primary" plain @click="handleAddGoods">添加商品</el-button>
            </div>
            <div v-if="item.tableData.length" class="setting">
                <el-form :model="setting" :rules="rules" ref="settingForm" label-width="0" label-position="left" size="mini">
                <div class="limit-btns" v-if="!disabled">
                    <div class="box" style="min-width: 40px;flex-basis: 40px;" v-if="!disabled"></div>
                    <div class="box" style="min-width: 280px;flex-basis: 280px;"></div>
                    <div class="box" style="min-width: 110px;flex-basis: 120px;">
                        <div class="innerbox" v-if="setting.discountrate.isShow">
                            <el-form-item label="" prop="discountrate.value" class="box" :rules='rules.discountrate2' style="width: 100%">
                                <el-input v-model.trim="setting.discountrate.value" placeholder="0.0" maxlength="4"></el-input>
                                <el-button type="text" size="small" @click="handleSetRate">确定</el-button>
                                <el-button type="text" size="small" @click="handleRate">取消</el-button>
                            </el-form-item>
                        </div>
                        <el-button type="info" plain @click="handleRate" v-else style="margin-top: -10px">批量打折</el-button>
                    </div>
                    <div class="box" style="min-width: 150px;flex-basis: 150px;">
                        <div class="innerbox" v-if="setting.deduceprice.isShow">
                            <el-form-item label="" prop="deduceprice.value" class="box" :rules='rules.deduceprice2' style="width: 100%">
                                <el-input v-model.trim="setting.deduceprice.value" placeholder="0.00"></el-input>
                                <el-button type="text" size="small" @click="handleSetPrice">确定</el-button>
                                <el-button type="text" size="small" @click="handlePrice">取消</el-button>
                            </el-form-item>
                        </div>
                        <el-button type="info" plain @click="handlePrice" v-else style="margin-top: -10px">批量减价</el-button>
                    </div>
                    <div class="box" style="min-width: 150px;flex-basis: 150px;">
                        <div class="check-boxs" style="margin-top: -10px">
                            <el-checkbox v-model="wipe.tenCents" @change="handleWipeTenCents">抹去角和分</el-checkbox>
                            <el-checkbox v-model="wipe.cents" @change="handleWipeCents">抹去分</el-checkbox>
                            <el-tooltip content="抹零是指价格不计整数以外的尾数；折后价低于1.00元的商品不能进行抹零" placement="top">
                                <div><i class="icon icon_warning"></i></div>
                            </el-tooltip>
                        </div>
                    </div>
                    <div class="box" style="min-width: 150px;flex-basis: 150px;">
                        <div class="innerbox" v-if="setting.limitcount.isShow">
                            <el-form-item label="" prop="limitcount.value" class="box" :rules='rules.limitcount' style="width: 100%">
                                <el-input v-model.trim="setting.limitcount.value" placeholder="0为不限"></el-input>
                                <el-button type="text" size="small" @click="handleSetLimit">确定</el-button>
                                <el-button type="text" size="small" @click="handleLimit">取消</el-button>
                            </el-form-item>
                        </div>
                        <div v-else style="display: flex;align-items: center;margin-top: -10px;">
                            <el-button type="info" plain @click="handleLimit"style="margin-right: 12px">批量限量</el-button>
                            <el-tooltip content="0为不限量" placement="top">
                                <div><i class="icon icon_warning"></i></div>
                            </el-tooltip>
                        </div>
                    </div>
                    <div class="box" style="min-width: 50px;flex-basis: 50px;"></div>
                </div>
                </el-form>
                <el-table :data="item.tableData" style="width: 100%;" :show-header="false" ref="multipleTable"
                          @select="handleSelectionChange">
                    <!--@row-click="handleRowChange"-->
                    <el-table-column type="selection" min-width="40" v-if="!disabled"></el-table-column>
                    <el-table-column label="活动名称" fixed class-name="left" min-width="280">
                        <template slot-scope="scope">
                            <div class="goods_item_box">
                                <div class="left">
                                    <img class="img" v-lazy="scope.row.coverurl" alt>
                                </div>
                                <div class="right">
                                    <div class="innerbox text-ellipse">{{scope.row.kmcname}}</div>
                                    <div class="tc-red innerbox">{{scope.row.oldsaleprice=='0.00'?'免费': '￥' +
                                        scope.row.oldsaleprice}}
                                    </div>
                                    <div class="innerbox tc-grey">{{scope.row.kmctype | kmctypename}}</div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="折扣" class-name="center discountrate" min-width="120">
                        <template slot-scope="scope">
                            <el-form-item label="" :prop="'tableData.'+ scope.$index + '.discountrate'"
                                          class="limit-box" :class="[scope.row.selectIndex == 1 ? 'selected' : '']"
                                          :rules='rules.discountrate'>
                                打
                                <el-input v-model.trim="scope.row.discountrate" placeholder="0.0"  maxlength="4"
                                          @input="_setDiscountrate(scope.row)" :disabled="disabled"></el-input>
                                折
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="减价" class-name="center" min-width="150">
                        <template slot-scope="scope">
                            <el-form-item label="" :prop="'tableData.'+ scope.$index + '.deduceprice'"
                                          class="limit-box" :class="[scope.row.selectIndex == 2 ? 'selected' : '']"
                                          :rules='rules.deduceprice'>
                                减价
                                <el-input v-model.trim="scope.row.deduceprice" placeholder="0.00"
                                          @input="_setDeduceprice(scope.row)"
                                          @blur="_setDeducepriceCents(scope.row)" :disabled="disabled"></el-input>
                                元
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="折后金额" class-name="center" min-width="150">
                        <template slot-scope="scope">
                            <el-form-item label="" :prop="'tableData.'+ scope.$index + '.newsaleprice'"
                                          class="limit-box newsaleprice"
                                          :class="[scope.row.selectIndex == 3 ? 'selected' : '']"
                                          :rules='rules.newsaleprice'>
                                现价
                                <el-input v-model.trim="scope.row.newsaleprice" placeholder="0.00"
                                          @input="_setNewsaleprice(scope.row)"
                                          @blur="_setsetNewsalepriceCents(scope.row)"
                                          :disabled="disabled"></el-input>
                                元
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="限量" class-name="center" min-width="150">
                        <template slot-scope="scope">
                            <el-form-item label="" :prop="'tableData.'+ scope.$index + '.limitcount'"
                                          class="limit-box" :class="[scope.row.limitcount ? 'selected' : '']"
                                          :rules='rules.limitcount'>
                                限量
                                <el-input v-model.trim="scope.row.limitcount" placeholder="0为不限"
                                          @input="_setLimitcount(scope.row)" :disabled="disabled"></el-input>
                                个
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" min-width="50" class-name="right" label-class-name="tr"
                                     v-if="!disabled">
                        <template slot-scope="scope">
                            <div class="tr">
                    <span class="separator-btn">
                        <el-button @click="handleDel(scope.$index)" type="text" size="small">取消</el-button>
                    </span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="limit-btns" v-if="!disabled">
                    <div class="box" style="justify-content: flex-start;">
                        <div class="check-boxs" style="justify-content: flex-start;">
                            <el-checkbox v-model="isChecked" @change="handleAllSelectionChange">全选</el-checkbox>
                            <el-button type="info" plain @click="handleSomeDel">批量取消</el-button>
                        </div>
                    </div>
                </div>
                <el-pagination background @current-change="_getList" :current-page.sync="page.page"
                               :page-size="page.pageSize"
                               :pager-count="11" layout="prev, pager, next" :total="item.kmcinfo.length">
                </el-pagination>
            </div>
            <el-form-item class="btnBox">
                <el-button @click="cancel">取消</el-button>
                <el-button type="primary" @click="submitForm" v-if="!disabled">提交</el-button>
            </el-form-item>
        </el-form>
    </div>
    <goodsListDialog ref="goodsListDialog" @setCourseQuesList="_setCourseQuesList"></goodsListDialog>
</div>
</template>

<script>
import {getLimitView, editLimit} from 'api/operateToolApi'
import {mapGetters, mapActions} from 'vuex'
import GoodsListDialog from 'views/operateTool/limittime/components/goodsListDialog.vue'
import $ from 'jquery'
import {_setClass, _filter, kmc} from 'api/enumCode'
import {numberRound} from 'common/js/tools'

export default {
    name: 'LimitTimeEdit',
    data() {
        let validateDiscountrate = (rule, value, callback) => {
            let index = rule.field.split('.')[1]
            let list = value.split('.')
            if (list.length > 1) {
                let decimal = list[1]
                if (decimal.length > 1) {
                    value = value.substring(0, value.length - 1)
                }
                this.item.tableData[index].discountrate = value
            }
            value = parseFloat(value)
            if (value == 0 || value > 10) {
                callback(new Error('0-10之间,1位小数'))
            } else {
                callback()
            }
        }
        let validateDeduceprice = (rule, value, callback) => {
            let index = rule.field.split('.')[1]
            let list = value.split('.')
            if (list.length > 1) {
                let decimal = list[1]
                if (decimal.length > 2) {
                    value = value.substring(0, value.length - 1)
                }
                this.item.tableData[index].deduceprice = value
            }
            let oldsaleprice = parseFloat(this.item.tableData[index].oldsaleprice)
            let deduceprice = parseFloat(value)
            if (deduceprice >= oldsaleprice) {
                callback(new Error('减价不能大于原价'))
            } else {
                callback()
            }
        }
        let validateNewsaleprice = (rule, value, callback) => {
            let index = rule.field.split('.')[1]
            let list = value.split('.')
            if (list.length > 1) {
                let decimal = list[1]
                if (decimal.length > 2) {
                    value = value.substring(0, value.length - 1)
                }
                this.item.tableData[index].newsaleprice = value
            }
            let oldsaleprice = parseFloat(this.item.tableData[index].oldsaleprice)
            let newsaleprice = parseFloat(value)
            if (newsaleprice <= 0) {
                callback(new Error('减价后金额需大于0'))
            } else if (newsaleprice > oldsaleprice) {
                callback(new Error('现价不能大于原价'))
            } else {
                callback()
            }
        }
        let validateDiscountrate2 = (rule, value, callback) => {
            let list = value.split('.')
            if (list.length > 1) {
                let decimal = list[1]
                if (decimal.length > 1) {
                    value = value.substring(0, value.length - 1)
                }
                this.setting.discountrate.value = value
            }
        }
        let validateDeduceprice2 = (rule, value, callback) => {
            let list = value.split('.')
            if (list.length > 1) {
                let decimal = list[1]
                if (decimal.length > 2) {
                    value = value.substring(0, value.length - 1)
                }
                this.setting.deduceprice.value = value
            }
        }
        return {
            item: {
                eventinnerid: this.$route.query.id ? this.$route.query.id : '', // 活动innerid
                assetname: '', // 活动名称
                timeSlot: [],
                begintime: '', // 活动开始时间，带时分秒 格式：yyyy-MM-dd HH:mm:ss
                endtime: '', // 活动结束时间，带时分秒 格式：yyyy-MM-dd HH:mm:ss
                tagname: '', // 活动标签，可显示在前端展示，2-5字
                status: '', // 状态：1 正常 9 暂停 10已完成 100已取消
                kmcinfo: [],
                tableData: [],
            },
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 0
            },
            rules: {
                assetname: [
                    {required: true, message: '请输入名称', trigger: 'blur'}
                ],
                tagname: [
                    {min: 2, message: '标签2-5个字', trigger: 'blur'}
                ],
                timeSlot: [
                    {required: true, message: '请选择活动时间', trigger: 'blur'}
                ],
                discountrate: [
                    {required: true, message: '请输入折扣', trigger: 'blur'},
                    {validator: validateDiscountrate, trigger: 'change'},
                    {validator: validateDiscountrate, trigger: 'blur'},
                    {pattern: /^([1-9][0-9]*)+(\.[0-9]{1})?$/, message: '0-10之间,1位小数', trigger: 'change'},
                    {pattern: /^([1-9][0-9]*)+(\.[0-9]{1})?$/, message: '0-10之间,1位小数', trigger: 'blur'}
                ],
                discountrate2: [
                    {required: true, message: '请输入折扣', trigger: 'blur'},
                    {validator: validateDiscountrate2, trigger: 'change'},
                    {validator: validateDiscountrate2, trigger: 'blur'},
                    {pattern: /^([1-9][0-9]*)+(\.[0-9]{1})?$/, message: '0-10之间,1位小数', trigger: 'change'},
                    {pattern: /^([1-9][0-9]*)+(\.[0-9]{1})?$/, message: '0-10之间,1位小数', trigger: 'blur'}
                ],
                deduceprice: [
                    {required: true, message: '请输入减价', trigger: 'blur'},
                    {validator: validateDeduceprice, trigger: 'change'},
                    {validator: validateDeduceprice, trigger: 'blur'},
                    {pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '输入数字，2位小数', trigger: 'change'},
                    {pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '输入数字，2位小数', trigger: 'blur'},
                ],
                deduceprice2: [
                    {required: true, message: '请输入减价', trigger: 'blur'},
                    {validator: validateDeduceprice2, trigger: 'change'},
                    {validator: validateDeduceprice2, trigger: 'blur'},
                    {pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '输入数字，2位小数', trigger: 'change'},
                    {pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '输入数字，2位小数', trigger: 'blur'}
                ],
                newsaleprice: [
                    {required: true, message: '请输入现价', trigger: 'blur'},
                    {validator: validateNewsaleprice, trigger: 'change'},
                    {validator: validateNewsaleprice, trigger: 'blur'},
                    {pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '输入数字，2位小数', trigger: 'change'},
                    {pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '输入数字，2位小数', trigger: 'blur'}
                ],
                limitcount: [
                    {pattern: /^(0|[1-9][0-9]*)$/, message: '请输入正整数', trigger: 'change'},
                    {pattern: /^(0|[1-9][0-9]*)$/, message: '请输入正整数', trigger: 'blur'}
                ]
            },
            setting:{
                discountrate: {
                    isShow: false,
                    value: ''
                },
                deduceprice: {
                    isShow: false,
                    value: ''
                },
                limitcount: {
                    isShow: false,
                    value: ''
                },
            },
            wipe: {
                tenCents: false,
                cents: false,
                len: 2 // 小数位数
            },
            isChecked: false,
            selected: [],
            disabled: false
        }
    },
    mounted() {
        if (this.item.eventinnerid) this._getView()
    },
    methods: {
        handleWipeTenCents() { // 抹去角和分
            if (this.wipe.tenCents) {
                this.wipe.len = 0
                this.wipe.cents = false
            } else {
                this.wipe.len = 2
            }
            // this._setCents()
        },
        handleWipeCents() { // 抹去分
            if (this.wipe.cents) {
                this.wipe.len = 1
                this.wipe.tenCents = false
            } else {
                this.wipe.len = 2
            }
            // this._setCents()
        },
        _setCents() {
            this.item.kmcinfo.forEach((o, i) => {
                let oldsaleprice = parseFloat(o.oldsaleprice)
                let discountrate = parseFloat(o.discountrate)
                let deduceprice = parseFloat(o.deduceprice)
                let newsaleprice = oldsaleprice * discountrate / 10
                if ((this.wipe.len == 1 && newsaleprice > 0.1) || (this.wipe.len == 0 && newsaleprice > 1)) {
                    o.newsaleprice = this._numberFloor(newsaleprice, this.wipe.len)
                } else {
                    o.newsaleprice = numberRound(newsaleprice, 2)
                }
                newsaleprice = parseFloat(o.newsaleprice)
                deduceprice = oldsaleprice - newsaleprice
                o.deduceprice = this._numberCeil(deduceprice, 2)
                discountrate = newsaleprice / oldsaleprice * 10
                o.discountrate = numberRound(discountrate, 1)
            })
        },
        handleRate() {
            this.setting.limitcount.isShow = false
            this.setting.deduceprice.isShow = false
            this.setting.discountrate.isShow = !this.setting.discountrate.isShow
            this.setting.discountrate.value = ''
            this.$refs.settingForm.clearValidate()
        },
        handleSetRate() {
            if (/^([1-9][0-9]*)+(\.[0-9]{1})?$/.test(this.setting.discountrate.value)) {
                let discountrate = parseFloat(this.setting.discountrate.value)
                if (discountrate == 0 || discountrate > 10) {
                    this.$message.error('请输入折扣（0-10之间）')
                } else {
                    this._setRate()
                    this.handleRate()
                }
            } else {
                this.$message.error('请输入折扣（最多1位小数）')
            }
        },
        _setRate() {
            this.item.kmcinfo.forEach((o, i) => {
                o.selectIndex = 1
                o.discountrate = this.setting.discountrate.value
                let discountrate = parseFloat(o.discountrate)
                let oldsaleprice = parseFloat(o.oldsaleprice)
                let newsaleprice = oldsaleprice * discountrate / 10
                if ((this.wipe.len == 1 && newsaleprice > 0.1) || (this.wipe.len == 0 && newsaleprice > 1)) {
                    o.newsaleprice = this._numberFloor(newsaleprice, this.wipe.len)
                } else {
                    o.newsaleprice = numberRound(newsaleprice, 2)
                }
                newsaleprice = parseFloat(o.newsaleprice)
                let deduceprice = oldsaleprice - newsaleprice
                o.deduceprice = this._numberCeil(deduceprice, 2)
                this.$refs.ruleForm.validate((valid, name) => {})
            })
        },
        handlePrice() {
            this.setting.limitcount.isShow = false
            this.setting.discountrate.isShow = false
            this.setting.deduceprice.isShow = !this.setting.deduceprice.isShow
            this.setting.deduceprice.value = ''
            this.$refs.settingForm.clearValidate()
        },
        handleSetPrice() {
            if (/^[0-9]+(\.[0-9]{1,2})?$/.test(this.setting.deduceprice.value)) {
                this._setPrice()
                this.handlePrice()
            } else {
                this.$message.error('请输入减价（最多2位小数）')
            }
        },
        _setPrice() {
            this.item.kmcinfo.forEach((o, i) => {
                o.selectIndex = 2
                o.deduceprice = this.setting.deduceprice.value
                let oldsaleprice = parseFloat(o.oldsaleprice)
                let deduceprice = parseFloat(o.deduceprice)
                let newsaleprice = oldsaleprice - deduceprice
                if ((this.wipe.len == 1 && newsaleprice > 0.1) || (this.wipe.len == 0 && newsaleprice > 1)) {
                    o.newsaleprice = this._numberFloor(newsaleprice, this.wipe.len)
                } else {
                    o.newsaleprice = numberRound(newsaleprice, 2)
                }
                newsaleprice = parseFloat(o.newsaleprice)
                deduceprice = oldsaleprice - newsaleprice
                o.deduceprice = this._numberCeil(deduceprice, 2)
                let discountrate = newsaleprice / oldsaleprice * 10
                o.discountrate = numberRound(discountrate, 1)
                this.$refs.ruleForm.validate((valid, name) => {})
            })
        },
        handleLimit() {
            this.setting.deduceprice.isShow = false
            this.setting.discountrate.isShow = false
            this.setting.limitcount.isShow = !this.setting.limitcount.isShow
            this.setting.limitcount.value = ''
        },
        handleSetLimit() {
            if (/^(0|[1-9][0-9]*)$/.test(this.setting.limitcount.value)) {
                this._setLimit()
                this.handleLimit()
            } else {
                this.$message.error('请输入限量（整数）')
            }
        },
        _setLimit() {
            this.item.kmcinfo.forEach((o, i) => {
                o.limitcount = this.setting.limitcount.value
            })
        },
        _setDiscountrate(row) { // 折扣
            row.selectIndex = 1
            let discountrate = parseFloat(row.discountrate)
            let oldsaleprice = parseFloat(row.oldsaleprice)
            if (!/^[0-9](\.[0-9]{1})?$/.test(row.discountrate)) {
                row.deduceprice = ''
                row.newsaleprice = row.oldsaleprice
            } else {
                let newsaleprice = oldsaleprice * discountrate / 10
                if ((this.wipe.len == 1 && newsaleprice > 0.1) || (this.wipe.len == 0 && newsaleprice > 1)) {
                    row.newsaleprice = this._numberFloor(newsaleprice, this.wipe.len)
                } else {
                    row.newsaleprice = numberRound(newsaleprice, 2)
                }
                let deduceprice = oldsaleprice - newsaleprice
                row.deduceprice = this._numberCeil(deduceprice, 2)
            }
        },
        _setDeduceprice(row) { // 减价
            row.selectIndex = 2
            let deduceprice = parseFloat(row.deduceprice)
            let oldsaleprice = parseFloat(row.oldsaleprice)
            let newsaleprice = oldsaleprice - deduceprice
            if ((this.wipe.len == 1 && newsaleprice > 0.1) || (this.wipe.len == 0 && newsaleprice > 1)) {
                row.newsaleprice = this._numberFloor(newsaleprice, this.wipe.len)
            } else {
                row.newsaleprice = numberRound(newsaleprice, 2)
            }
            newsaleprice = parseFloat(row.newsaleprice)
            let discountrate = newsaleprice / oldsaleprice * 10
            row.discountrate = numberRound(discountrate, 1)
        },
        _setDeducepriceCents(row) {
            let oldsaleprice = parseFloat(row.oldsaleprice)
            let deduceprice = parseFloat(row.deduceprice)
            let newsaleprice = parseFloat(row.newsaleprice)
            deduceprice = oldsaleprice - newsaleprice
            row.deduceprice = this._numberCeil(deduceprice, 2)
        },
        _setNewsaleprice(row) { // 现价
            row.selectIndex = 3
            let oldsaleprice = parseFloat(row.oldsaleprice)
            let newsaleprice = parseFloat(row.newsaleprice)
            if (!/^[0-9]+(\.[0-9]{1,2})?$/.test(row.newsaleprice) || newsaleprice > oldsaleprice) {
                row.discountrate = ''
                row.deduceprice = ''
            } else {
                let deduceprice = oldsaleprice - newsaleprice
                row.deduceprice = this._numberCeil(deduceprice, 2)
                let discountrate = newsaleprice / oldsaleprice * 10
                row.discountrate = numberRound(discountrate, 1)
            }
        },
        _setsetNewsalepriceCents(row) {
            let oldsaleprice = parseFloat(row.oldsaleprice)
            let newsaleprice = parseFloat(row.newsaleprice)
            if ((this.wipe.len == 1 && newsaleprice > 0.1) || (this.wipe.len == 0 && newsaleprice > 1)) {
                row.newsaleprice = this._numberFloor(newsaleprice, this.wipe.len)
            } else {
                row.newsaleprice = numberRound(newsaleprice, 2)
            }
            newsaleprice = parseFloat(row.newsaleprice)
            let deduceprice = oldsaleprice - newsaleprice
            row.deduceprice = this._numberCeil(deduceprice, 2)
            let discountrate = newsaleprice / oldsaleprice * 10
            row.discountrate = numberRound(discountrate, 1)
        },
        _setLimitcount(row) {
        },
        handleSelectionChange(selection, row) {
            this.selected = selection
            if (this.selected.length == this.item.tableData.length) {
                this.isChecked = true
            } else {
                this.isChecked = false
            }
        },
        handleAllSelectionChange() {
            if (this.isChecked) {
                this.selected = this.item.tableData
                this.selected.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row, true)
                })
            } else {
                this.$refs.multipleTable.clearSelection()
                this.selected = []
            }
        },
        handleRowChange(row, column, event) {
            let flag = false
            this.selected.forEach((obj, i) => {
                if (row.kmcinnerid == obj.kmcinnerid) {
                    this.$refs.multipleTable.toggleRowSelection(row, false)
                    this.selected.splice(i, 1)
                    flag = true
                }
            })
            if (!flag) {
                this.$refs.multipleTable.toggleRowSelection(row)
                this.selected.push(row)
            }
        },
        handleDel(index) {
            let idx = (this.page.page - 1) * this.page.pageSize + index
            this.item.kmcinfo.splice(idx, 1)
            this.page.page = 1
            this._getList()
        },
        handleSomeDel() {
            if (!this.selected.length) {
                this.$message.error('请选择需要取消的商品')
                return false
            }
            this.selected.forEach((obj1, i) => {
                this.item.kmcinfo.forEach((obj2, j) => {
                    if (obj1.kmcinnerid == obj2.kmcinnerid) {
                        delete this.item.kmcinfo[j]
                    }
                })
            })
            this.isChecked = false
            this.item.kmcinfo = this.item.kmcinfo.filter(o => o)
            this.page.page = 1
            this._getList()
        },
        handleAddGoods() {
            this.$refs.goodsListDialog.openDialog(this.item.kmcinfo)
        },
        _setCourseQuesList(selectedResult) {
            this.item.kmcinfo = selectedResult
            this.page.page = 1
            this.page.pageCount = parseInt(this.item.kmcinfo.length / 10) + 1
            this._getList()
        },
        cancel() {
            this.$router.back()
        },
        submitForm() {
            this.$refs.ruleForm.validate((valid, name) => {
                if (valid) {
                    if (!this.item.kmcinfo.length) {
                        this.$message.error('请选择商品')
                        return false
                    }
                    let flag = true
                    this.item.kmcinfo.forEach((o, i) => {
                        if (!o.discountrate || !o.deduceprice || !o.newsaleprice) {
                            this.page.page = parseInt(i / this.page.pageSize) + 1
                            this._getList()
                            this.$refs.ruleForm.validate()
                            flag = false
                            return false
                        }
                    })
                    if (flag) {
                        let obj = $.extend(true, {}, this.item)
                        this._submit(obj)
                    }
                }
            })
        },
        _submit(obj) {
            obj.begintime = obj.timeSlot[0]
            obj.endtime = obj.timeSlot[1]
            obj.kmcinfo.forEach((o, i) => {
                o.discountrate = o.discountrate ? o.discountrate : 0
                o.deduceprice = o.deduceprice ? o.deduceprice : 0
                o.newsaleprice = o.newsaleprice ? o.newsaleprice : 0
                o.limitcount = o.limitcount ? o.limitcount : 0
                delete o.kmctypename
                delete o.selectIndex
            })
            obj.kmcinfo = JSON.stringify(obj.kmcinfo)
            delete obj.timeSlot
            delete obj.status
            delete obj.tableData
            this.setLoading(true)
            editLimit({
                data: obj,
                success: data => {
                    this.setLoading(false)
                    this.cancel()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.selected = []
            let start = (this.page.page - 1) * this.page.pageSize
            let end = (this.page.page - 1) * this.page.pageSize + (this.page.pageSize)
            this.$set(this.item, 'tableData', this.item.kmcinfo.slice(start, end))
        },
        _getView() {
            this.setLoading(true)
            getLimitView({
                data: Object.assign({}, {eventinnerid: this.item.eventinnerid}),
                success: data => {
                    data.data.timeSlot = [data.data.begintime, data.data.endtime]
                    data.data.kmcinfo.forEach((o, i) => {
                        o.limitcount = o.limitcount ? o.limitcount : ''
                        o.selectIndex = 1
                    })
                    data.data.tableData = []
                    this.item = data.data
                    this.disabled = [10, 100].indexOf(this.item.status) > -1
                    this._getList()
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _numberFloor(num, length) { // 向下
            let len = length
            if (isNaN(num)) {
                return '不是数字'
            } else {
                const p1 = Math.pow(10, len + 1)
                const p2 = Math.pow(10, len)
                let number = (Math.floor(num * p1 / 10) / p2).toFixed(len)
                return number
            }
        },
        _numberCeil(num, length) { // 向上
            let len = length ? length : 0
            if (isNaN(num)) {
                return '不是数字'
            } else {
                return num.toFixed(len)
            }
        },
        ...mapActions(['setLoading'])
    },
    filters: {
        kmctypename: function (value) {
            return _filter(value, kmc.type)
        }
    },
    watch: {},
    computed: {},
    components: {
        GoodsListDialog
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.LimitTimeEdit {
    .account-form {
        margin-top: 20px !important;
    }
    .box {
        .el-form-item__content {
            width: 630px;
        }
    }
    .setting .box .el-form-item__content{
        width: auto;
    }
    .tagname {
        .el-form-item__content {
            width: 300px;
        }
    }
    .tip {
        color: #999;
        font-size: 14px;
        margin-top: 10px;
    }
    .limit-btns {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 60px;
        .box {
            flex-grow: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            .check-boxs {
                display: flex;
                align-items: center;
                justify-content: center;
                .el-checkbox {
                    margin-right: 10px;
                }
                .el-checkbox__label {
                    font-size: 12px;
                }
                .el-tooltip {
                    width: auto;
                }
            }
            input{
                padding: 0 5px !important;
            }
            .icon {
                &:before {
                    width: 14px;
                    height: 14px;
                }
            }
            .el-button, .el-input {
                width: 78px;
                min-width: 78px;
                height: 28px;
                line-height: 28px;
                text-align: center;
                font-size: 12px;
                box-sizing: border-box;
            }
            .innerbox {
                display: flex;
                .el-button {
                    width: auto;
                    min-width: auto;
                }
                .el-input {
                    margin-right: 5px;
                    padding: 0 5px;
                    input {
                        height: 28px;
                    }
                }
            }
        }
    }
    .goods_item_box {
        display: flex;
        align-items: center;
        height: 60px;
        box-sizing: border-box;
        .left {
            position: relative;
            margin-right: 12px;
            .img {
                width: 106px;
                height: 60px;
            }
        }
        .right {
            flex-grow: 1;
            overflow: hidden;
            .innerbox {
                margin-right: 20px;
            }
        }
    }
    .el-table {
        .el-form-item__content {
            width: 100%;
            margin-left: 0 !important;
            .el-input {
                width: 64px;
                margin: 0 5px;
                input {
                    padding: 0 5px;
                }
            }
        }
        .discountrate {
            .el-input {
                width: 40px;
            }
        }
        .el-button, .el-button--mini {
            min-width: auto;
        }
        .limit-box {
            padding-top: 18px;
            color: #999999;
            input {
                color: #999999;
            }
        }
        .limit-box.newsaleprice {
            color: #333333;
            font-weight: 600;
        }
        .limit-box.selected {
            color: #333333;
            font-weight: 600;
            input {
                color: #333333;
                font-weight: 600;
            }
        }
        .limit-box.newsaleprice.selected {
            input {
                color: #F56C6C;
            }
        }
    }
    .btnBox {
        .el-form-item__content {
            margin-left: 0 !important;
        }
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }
    .el-pagination {
        margin-top: 20px;
        text-align: center;
    }
    .el-table-column--selection .cell {
        padding-right: 0;
    }
}
</style>
